import { ChangeDetectionStrategy, Component, Input, OnChanges } from '@angular/core';
import { FacebookReactionType } from '@sb-tools/typescript/enums/facebook-reaction-type.enum';
import { FacebookReaction } from '@sb-tools/typescript/models/facebook-reaction.model';
import { ReactionTooltipTextType } from '../../../../core/enums/reaction-tooltip-text-type.enum';
import { TranslateService } from '@ngx-translate/core';
import { TitleCasePipe } from '@angular/common';
import { ReactionIconComponent } from '../reaction-icon/reaction-icon.component';

const DISPLAYED_SENDERS_MAX_COUNT = 20;

@Component({
    selector: 'app-reactions',
    templateUrl: './reactions.component.html',
    styleUrls: ['./reactions.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [ReactionIconComponent],
    providers: [TitleCasePipe],
})
export class ReactionsComponent implements OnChanges {
    @Input() isShowTotalCount?: boolean;
    @Input() isShowReactionCount?: boolean;
    @Input() tooltipTextType?: ReactionTooltipTextType;
    @Input() isSingleEmoji?: boolean;
    @Input() reactions: FacebookReaction[];
    @Input() updateReactionsMarker;

    facebookReactionType = FacebookReactionType;
    filteredReactions: FacebookReaction[];
    reactionsCount: number;
    reactionTooltipTextType = ReactionTooltipTextType;
    standardFacebookReactionsList = [];

    constructor(
        private translateService: TranslateService,
        private titleCasePipe: TitleCasePipe,
    ) {
        this.standardFacebookReactionsList = [
            this.facebookReactionType.angry,
            this.facebookReactionType.like,
            this.facebookReactionType.love,
            this.facebookReactionType.haha,
            this.facebookReactionType.wow,
            this.facebookReactionType.sad,
        ];
    }

    ngOnChanges(): void {
        this.filteredReactions = this.reactions.filter((reaction) => {
            return reaction.count > 0;
        });

        if (this.isShowTotalCount) {
            this.reactionsCount = this.getReactionsCount();
        }

        if (this.tooltipTextType) {
            this.initTooltipText();
        }
    }

    private getReactionsCount(): number {
        let count = 0;

        this.reactions.forEach((reaction) => {
            count += reaction.count;
        });

        return count;
    }

    private initTooltipText(): void {
        switch (this.tooltipTextType) {
            case this.reactionTooltipTextType.nameAndSenders: {
                this.filteredReactions.forEach((reaction) => {
                    this.processReactionTooltipHtml(reaction);
                });
                break;
            }

            case this.reactionTooltipTextType.senders: {
                this.filteredReactions.forEach((reaction) => {
                    reaction.tooltipText = (reaction.senders?.length && reaction.senders.join(',')) || '';
                });
                break;
            }

            case this.reactionTooltipTextType.name: {
                this.filteredReactions.forEach((reaction) => {
                    reaction.tooltipText = this.titleCasePipe.transform(this.facebookReactionType[reaction.type]);
                });
                break;
            }
        }
    }

    private processReactionTooltipHtml(reaction: FacebookReaction): void {
        reaction.tooltipText = '';

        if (this.standardFacebookReactionsList.includes(reaction.type)) {
            reaction.tooltipText +=
                '<h6 class="text-capitalize mb-0">' +
                this.facebookReactionType[reaction.type] +
                '</h6>' +
                (reaction.senders.length ? '<div class="mb-2">' : '');
        }

        reaction.senders.forEach((sender, index, list) => {
            if (index >= DISPLAYED_SENDERS_MAX_COUNT) {
                return;
            }

            if (index === DISPLAYED_SENDERS_MAX_COUNT - 1) {
                reaction.tooltipText +=
                    '<div>' +
                    this.translateService.instant('and') +
                    ' ' +
                    (list.length - DISPLAYED_SENDERS_MAX_COUNT) +
                    ' ' +
                    this.translateService.instant('more') +
                    '</div>';
                return;
            }

            reaction.tooltipText += '<div>' + sender + '</div>';
        });
    }
}
